import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a344b938"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emEdicao" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Edição de Questão", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "opcoes" }
const _hoisted_6 = {
  key: 2,
  class: "erro"
}
const _hoisted_7 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IdFormularioFactory = _resolveComponent("IdFormularioFactory")!
  const _component_TituloInput = _resolveComponent("TituloInput")!
  const _component_SubtituloInput = _resolveComponent("SubtituloInput")!
  const _component_ValorPadraoSelecao = _resolveComponent("ValorPadraoSelecao")!
  const _component_ListaOpcoes = _resolveComponent("ListaOpcoes")!
  const _component_BotoesSalvarCancelar = _resolveComponent("BotoesSalvarCancelar")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_IdFormularioFactory, {
      titulo: (_ctx.titulo as Titulo),
      onGerouId: _ctx.gerouId
    }, null, 8, ["titulo", "onGerouId"]),
    _createVNode(_component_TituloInput, {
      titulo: (_ctx.titulo as Titulo),
      onDigitou: _ctx.digitouTitulo
    }, null, 8, ["titulo", "onDigitou"]),
    _createVNode(_component_SubtituloInput, {
      subtitulo: (_ctx.subtitulo as Subtitulo),
      onDigitou: _ctx.digitouSubtitulo
    }, null, 8, ["subtitulo", "onDigitou"]),
    (_ctx.valorPadrao)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_ValorPadraoSelecao, {
            listaOpcoes: (_ctx.opcoes as ListaEditavel<OpcaoEditavel>),
            selecionado: _ctx.valorPadrao as IdFormulario,
            onSelecionou: _ctx.selecionouValorPadrao
          }, null, 8, ["listaOpcoes", "selecionado", "onSelecionou"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ValorPadraoSelecao, {
            listaOpcoes: (_ctx.opcoes as ListaEditavel<OpcaoEditavel>),
            onSelecionou: _ctx.selecionouValorPadrao
          }, null, 8, ["listaOpcoes", "onSelecionou"])
        ])),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ListaOpcoes, {
        lista: (_ctx.opcoes as ListaEditavel<OpcaoEditavel>)
      }, null, 8, ["lista"])
    ]),
    (_ctx.erro)
      ? (_openBlock(), _createElementBlock("article", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.erro) + " ", 1),
          (_ctx.inconsistencias.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createTextVNode(" Inconsistências: "),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inconsistencias, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", null, [
      _createVNode(_component_BotoesSalvarCancelar, {
        onCancelou: _ctx.cancelar,
        onSalvou: _ctx.salvar
      }, null, 8, ["onCancelou", "onSalvou"])
    ])
  ]))
}